import { Response } from '@helpers/Models';

export const AuthProvider = {
  /**
   * Logs out the user by removing the authentication token from localStorage.
   * @returns {Promise<boolean>} A promise that resolves to true when the token is removed.
   */
  logout: async (): Promise<Response> => {
    //remove all local storage items
    localStorage.clear();

    return {
      success: true,
      redirectTo: '/login',
    };
  },

  /**
   * Checks the authentication status of the user.
   * @returns {boolean} A promise that resolves to an object containing the authentication status and a redirect URL.
   */
  checkAuth: (): boolean => {
    const token = localStorage.getItem('authToken');
    if (token) {
      // Token exists, return authenticated status
      return true;
    }
    //  unauthenticated status if token not found
    return false;
  },
};

/**
 * Retrieves the authentication token from localStorage.
 * @returns {string | null} The authentication token if it exists, otherwise null.
 */
export const getAuthToken = (): string | null => {
  return localStorage.getItem('authToken');
};
